module.exports = {
      id: "minus-usage",
      viewBox: "0 0 512 512",
      url: "/" + "sprite-ab56b996b385d9abaaf31e01c38c81cd.svg#minus",
      toString: function () {
        return this.url;
      }
    }